import { memo } from 'react';
import './NeuralSpinner.css';

const SIZES = {
  xs: { wrapper: 16, ring: 14, stroke: 1.5, cap: 3 },
  sm: { wrapper: 22, ring: 20, stroke: 2,   cap: 4 },
  md: { wrapper: 52, ring: 48, stroke: 4,   cap: 8 },
  lg: { wrapper: 68, ring: 64, stroke: 5,   cap: 10 },
};

const NeuralSpinner = memo(function NeuralSpinner({ size = 'md', className = '' }) {
  const s = SIZES[size] ?? SIZES.md;
  const halfWrapper = s.wrapper / 2;
  const halfCap = s.cap / 2;

  const ringStyle = {
    width: s.ring,
    height: s.ring,
    borderRadius: '50%',
    background: 'conic-gradient(from 0deg, transparent 0%, transparent 22%, #22d3ee 50%, #4f7aff 78%, #4f7aff 100%)',
    WebkitMask: `radial-gradient(farthest-side, transparent calc(100% - ${s.stroke}px), white calc(100% - ${s.stroke}px))`,
    mask: `radial-gradient(farthest-side, transparent calc(100% - ${s.stroke}px), white calc(100% - ${s.stroke}px))`,
    animation: 'neural-spin 0.85s linear infinite',
    flexShrink: 0,
  };

  const capStyle = {
    position: 'absolute',
    width: s.cap,
    height: s.cap,
    borderRadius: '50%',
    background: '#22d3ee',
    top: 0,
    left: '50%',
    marginLeft: -halfCap,
    transformOrigin: `${halfCap}px ${halfWrapper}px`,
    animation: 'neural-spin 0.85s linear infinite',
    boxShadow: `0 0 ${s.cap * 1.4}px #22d3ee, 0 0 ${s.cap * 2.8}px rgba(34,211,238,0.22)`,
  };

  return (
    <div
      data-testid="neural-spinner"
      className={`relative flex items-center justify-center flex-shrink-0 ${className}`}
      style={{ width: s.wrapper, height: s.wrapper }}
    >
      <div style={ringStyle} />
      <div style={capStyle} />
    </div>
  );
});

export default NeuralSpinner;
